import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import './cookie_pop.css';

export const COOKIE_KEY = 'agreeCookie';

// 내부용 쿠키 함수니까 실제 쿠키를 쓸 거면 react-cookie 등을 쓰는 걸 고려해주세요
// 쿠키 배너는 쿠키 배너대로 그냥 냅두세요
// 이 파일과 cookie_pop.css 가 일종의 라이브러리라고 치고
interface CookieItem {
  key: string;
  value: string;
}
type Cookies = CookieItem[];

function parseCookie(): Cookies {
  const cookies = document.cookie.split('; ');
  return cookies
    .map(itemString => itemString.split('='))
    .map(([key, ...value]) => ({
      key: decodeURIComponent(key),
      value: value.join('='),
    }));
}

function getCookie(key: 'agreeCookie'): string | null {
  const cookies = parseCookie();
  const result = cookies.find(cookie => cookie.key === key);
  return result?.value ?? null;
}

function setCookie(key: 'agreeCookie', value: '0' | '1') {
  document.cookie = `${encodeURIComponent(key)}=${value};max-age=${
    +new Date() + 1000 * 3600 * 24 * 400 // 400일 동안 유효 (크롬이 최대 400일 유효)
  }`;
}

export const CookieBanner = () => {
  const [agree, setAgree] = useState(getCookie(COOKIE_KEY));
  const { t } = useTranslation('translation', {
    keyPrefix: 'layout.cookieBanner',
  });

  const handleAgree = () => {
    setCookie(COOKIE_KEY, '1');
    setAgree('1');
  };

  const handleDisagree = () => {
    setCookie(COOKIE_KEY, '0');
    setAgree('0');
  };

  return agree === null ? (
    <div className="cookie_pop">
      <div className="inner">
        <p className="txt">
          <Trans
            t={t}
            i18nKey="message"
            components={{
              Link: (
                <a
                  href="/terms-v2#personalInformation"
                  className=""
                  target="_blank"
                />
              ),
              Newline: <br className="w_br" />,
            }}
          />
        </p>
        <p className="btn">
          <a className="btnSt bt_over agree_cookie" onClick={handleAgree}>
            {t('agree')}
          </a>
          {/*
          <a className="btnSt bt_over agree_cookie" onClick={handleDisagree}>
            거절
          </a>
          */}
        </p>
      </div>
    </div>
  ) : null;
};
